export default __webpack_public_path__ + "priority.png";